export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/inspection-hub-stars.17b7dd8d.svg","height":44,"width":89,"blurWidth":0,"blurHeight":0};